import React, { useEffect, useState } from "react";
import {
  Rating,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { fechaActualStr } from "../../util/Functions";
import {
  createValoracion,
  deleteValoracion,
  updateValoracion,
} from "../Valoracion/Valoracion-Api";

const IaxValoracionDialog = ({ open, onClose, actividad }) => {
  const valor = actividad != null ? actividad.valoracion?.valoracion : 0;
  const comentario = actividad != null ? actividad.valoracion?.comentario : "";
  const [value, setValue] = useState(valor);
  const [comment, setComment] = useState(comentario);

  useEffect(() => {
    setValue(actividad.valoracion?.valoracion);
    setComment(actividad.valoracion?.comentario);
  }, [open]);

  const handleRatingChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleSave = () => {
    // Aquí podrías manejar la lógica para guardar la valoración y el comentario
    console.log(`Valoración: ${value}, Comentario: ${comment}`);
    const idval =
      actividad.valoracion?.id != null ? actividad.valoracion?.id : 0;
    const valoracion = {
      id: idval,
      valoracion: value,
      comentario: comment,
      activado: true,
      fecha: fechaActualStr(),
      usuario: actividad.profesorResponsable,
    };
    if (idval == 0) {
      createValoracion(valoracion, actividad.id, onClose); // Cerrar el diálogo después de guardar
    } else {
      updateValoracion(valoracion, actividad.id, onClose);
    }
  };

  const handleCancel = () => {
    // Aquí podrías manejar la lógica para cancelar la acción
    setValue(3);
    setComment("");
    onClose(); // Cerrar el diálogo después de cancelar
  };

  const handleDelete = () => {
    deleteValoracion(actividad.valoracion.id, onClose);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Valorar</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Rating
            name="simple-controlled"
            value={value}
            onChange={handleRatingChange}
            precision={1}
            icon={<StarIcon fontSize="inherit" />}
          />
          <TextField
            label="Comentario"
            multiline
            rows={4}
            value={comment}
            onChange={handleCommentChange}
            style={{ marginTop: "10px" }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Guardar
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleCancel}>
          Cancelar
        </Button>
        {actividad.valoracion != null ? (
          <Button variant="contained" color="error" onClick={handleDelete}>
            Eliminar
          </Button>
        ) : (
          ""
        )}
      </DialogActions>
    </Dialog>
  );
};

export default IaxValoracionDialog;
